import { TFunction } from 'i18next';

import { MemoryKind } from 'src/Services/API/Memories.api';

export const MEMORY_KINDS: MemoryKind[] = [
  MemoryKind.Family,
  MemoryKind.Celebration,
  MemoryKind.House,
  MemoryKind.Works,
  MemoryKind.InMemory,
];

// Mantine palette names. "En mémoire" stays a sober grey: never a coloured badge.
export const MEMORY_KIND_COLOR: Record<MemoryKind, string> = {
  [MemoryKind.Family]: 'blue',
  [MemoryKind.Celebration]: 'grape',
  [MemoryKind.House]: 'teal',
  [MemoryKind.Works]: 'orange',
  [MemoryKind.InMemory]: 'gray',
};

export const memoryKindLabel = (t: TFunction, kind: MemoryKind | null): string => {
  switch (kind) {
    case MemoryKind.Family:
      return t('memories.kinds.FAMILY', 'Famille');
    case MemoryKind.Celebration:
      return t('memories.kinds.CELEBRATION', 'Fête');
    case MemoryKind.House:
      return t('memories.kinds.HOUSE', 'La maison');
    case MemoryKind.Works:
      return t('memories.kinds.WORKS', 'Travaux');
    case MemoryKind.InMemory:
      return t('memories.kinds.IN_MEMORY', 'En mémoire');
    default:
      return t('memories.kinds.none', 'Sans catégorie');
  }
};
